module.exports = __webpack_public_path__ + "static/media/sign-popup-img.af628a85.svg";